import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

/**
 * One headline number on Home: a label, the number and a caption. Clickable when `onClick` is set.
 * While loading it shows a placeholder bar; on error a short message instead of the number.
 */
const StatsCard = ({ title, caption, value, icon, isLoading = false, error = null, onClick }) => {
  const renderValue = () => {
    if (isLoading) {
      return <span aria-label="Loading" className="ui-skeleton mt-1 block h-8 w-20" />;
    }
    if (error) {
      return <span className="mt-1 block text-sm font-medium text-red-700 dark:text-red-300">Could not load</span>;
    }
    return <span className="mt-0.5 block text-[28px] leading-9 font-semibold tracking-tight text-ui-ink tabular-nums">{value ?? '—'}</span>;
  };

  const content = (
    <>
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-sm font-medium text-ui-ink-2">
          <span aria-hidden className="text-ui-ink-3 [&>svg]:size-4">{icon}</span>
          {title}
        </span>
        {onClick && <LuChevronRight aria-hidden className="size-4 text-ui-ink-3 transition-transform group-hover:translate-x-0.5" />}
      </div>
      {renderValue()}
      {caption && <span className="mt-0.5 block truncate text-xs text-ui-ink-3">{caption}</span>}
    </>
  );

  const classes = 'group block w-full rounded-xl border border-ui-line bg-ui-card px-5 py-4 text-left shadow-card';

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${classes} transition-colors hover:border-neutral-300 dark:hover:border-neutral-600`}>
        {content}
      </button>
    );
  }

  return <div className={classes}>{content}</div>;
};

export default StatsCard;
